import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { withRouter, RouteComponentProps } from 'react-router';

import Styled from 'styled';

import { Bazaar } from 'four-nets/bazaar/bazaar';
import { MyBazaarType } from 'four-nets/bazaar/my-bazaar/my-bazaar-table/query.graphql.types';

import { tableTypeToPath } from '../bazaar-loader';

import defaultStyles from './my-bazaar-filter-view.scss';

export interface Props extends RouteComponentProps {
    styles: typeof defaultStyles;
    bazaar: Bazaar;
    type: MyBazaarType;
}

@observer
class MyBazaarFilterView extends React.Component<Props> {
    changeCatgory = (type: MyBazaarType) => () => {
        const path = tableTypeToPath(type);
        this.props.history.push(path);
    };

    render() {
        const { bazaar, type } = this.props;
        const styles = this.props.styles!;

        return (
            <div className={styles.filterBar}>
                <button
                    onClick={this.changeCatgory(MyBazaarType.SELLING)}
                    className={classnames(styles.headingStyle, {
                        [styles.current]: Boolean(!type || MyBazaarType.SELLING === type),
                    })}
                >
                    <FormattedMessage id='BAZAAR_MY_PRODUCTS' />
                    {bazaar && bazaar.sellingMessagesCount ? (
                        <span className={styles.highlight}>
                            <FormattedMessage
                                id='%(counter)s_NEW_CONTACT_MESSAGES'
                                values={{ counter: bazaar && bazaar.sellingMessagesCount }}
                            />
                        </span>
                    ) : null}
                </button>
                <button
                    onClick={this.changeCatgory(MyBazaarType.SHOPPING)}
                    className={classnames(styles.headingStyle, {
                        [styles.current]: Boolean(!type || MyBazaarType.SHOPPING === type),
                    })}
                >
                    <FormattedMessage id='BAZAAR_MY_SHOPPING' />
                    {bazaar && bazaar.shoppingMessagesCount ? (
                        <span className={styles.highlight}>
                            <FormattedMessage
                                id='%(counter)s_NEW_CONTACT_MESSAGES'
                                values={{ counter: bazaar && bazaar.shoppingMessagesCount }}
                            />
                        </span>
                    ) : null}
                </button>
                <button
                    onClick={this.changeCatgory(MyBazaarType.WISHLIST)}
                    className={classnames(styles.headingStyle, {
                        [styles.current]: Boolean(!type || MyBazaarType.WISHLIST === type),
                    })}
                >
                    <FormattedMessage id='BAZAAR_MY_WISHLIST' />
                </button>
            </div>
        );
    }
}

export default Styled(defaultStyles)(withRouter(MyBazaarFilterView));
